import { getEventConfig } from './Utils/jfsEventMapping';
export class ParentAppInterface {
  private static instance: ParentAppInterface;
  private pendingPromises: Record<
    string,
    {
      resolve: (value: unknown) => void;
      reject: (reason?: any) => void;
      promise: Promise<unknown>;
    }
  > = {};

  private canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );

  private constructor() {
    if (this.canUseDOM) {
      // Bind the handler once when class is created
      (window as any).sendJwtAuthToken = (data: any) => {
        this.handleResponse(data, 'getJwtAuthToken');
      };
      (window as any).handleBackKey = () => {
        (window as any).handleHardwareBackButton();
      };
      (window as any).postOTP = (jsonString: string) => {
        if (typeof jsonString !== 'string') return;
        try {
          const parsed = JSON.parse(jsonString);
          if (parsed.encodedPayload) {
            this.forwardOTPToAA(parsed.encodedPayload);
          }
        } catch (error) {
        }
      };
    }
  }

  public static getInstance(): ParentAppInterface {
    if (!ParentAppInterface.instance) {
      ParentAppInterface.instance = new ParentAppInterface();
    }
    return ParentAppInterface.instance;
  }

  private handleResponse(dataObj: object, resolveKey: string): void {
    const promiseEntry = this.pendingPromises[resolveKey];
    if (promiseEntry?.resolve) {
      promiseEntry.resolve(dataObj);
      delete this.pendingPromises[resolveKey];
    }
  }

  private sendToApp(payload: any): void {
    const encodedData = window.btoa(JSON.stringify(payload));

    if ((window as any).android && (window as any).android.__externalCall) {
      (window as any).android.__externalCall(encodedData);
    } else if ((window as any).__externalCall) {
      (window as any).__externalCall(encodedData);
    } else if (
      this.isIOS() &&
      typeof (window as any).webkit?.messageHandlers?.callback?.postMessage === 'function'
    ) {
      (window as any).webkit?.messageHandlers?.callback?.postMessage(encodedData);
    } else if ((window as any).ReactNativeWebView?.postMessage) {
      (window as any).ReactNativeWebView.postMessage(encodedData);
    } else {
      console.warn('No native bridge available to send message');
    }
  }
  private isIOS(): boolean {
    if (typeof navigator === 'undefined') return false; // SSR safety
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }
  private sendMessage(payload: {
    type: string;
    [key: string]: any;
  }): Promise<unknown> {
    const type = payload.type;

    if (!this.pendingPromises[type]) {
      let resolve: (value: unknown) => void;
      let reject: (reason?: any) => void;

      const promise = new Promise<unknown>((res, rej) => {
        resolve = res;
        reject = rej;
      });

      // Add timeout to reject if no response
      const timeoutId = setTimeout(() => {
        reject(new Error(`Timeout waiting for ${type} response`));
        delete this.pendingPromises[type];
      }, 10000);

      this.pendingPromises[type] = {
        promise,
        resolve: (value) => {
          clearTimeout(timeoutId);
          resolve(value);
        },
        reject: (reason) => {
          clearTimeout(timeoutId);
          reject(reason);
        },
      };
    }

    this.sendToApp(payload);
    return this.pendingPromises[type].promise;
  }

  public getJwtAuthToken(): Promise<any> {
    return this.sendMessage({
      type: 'getJwtAuthToken',
      microAppID: 'IGNOSIS',
    });
  }
  public startBackHandling() {
    // If False we will get event from app
    this.sendToApp({ type: 'handleWebviewBack', value: false });
  }
  public closeWebview() {
    console.log('CLose webview');
    this.sendToApp({ event: 'GO_HOME' });
  }

  private forwardOTPToAA(encodedPayload: string): void {
    try {
      const payload = JSON.parse(atob(encodedPayload));
      if (!payload.otp) return;

      const frame = document.getElementById('aa-wrapper-iframe') as HTMLIFrameElement;
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage({ OTP: payload.otp }, '*');
      }
    } catch (error) {
    }
  }

  public sendEventToApp(eventCode: string): void {
    const config = getEventConfig(eventCode);

    if (config !== null) {
      const payload = {
        type: 'web_ga',
        value: config.eventType,
        gaTag: {
          event: eventCode,
          ctEvent: config.ctEvent,
          firebaseEvent: true,
          appsflyerEvent: config.appsflyerEvent,
          clickStreamEvents: true,
          channel_name: 'Ignosis',
          eventNameForAppsFlyer: config.appsflyerEvent ? eventCode : 'NA',
        },
      };

      this.sendToApp(payload);
    }
  }
}
